export const HIT_LIST_EMPLOYEE = "HIT_LIST_EMPLOYEE";
export const GET_LIST_EMPLOYEE = "GET_LIST_EMPLOYEE";
export const GET_LIST_EMPLOYEE_LIMIT = "GET_LIST_EMPLOYEE_LIMIT";

export const HIT_LIST_ORGANIZATION = "HIT_LIST_ORGANIZATION";
export const GET_LIST_ORGANIZATION = "GET_LIST_ORGANIZATION";
export const GET_LIST_ORGANIZATION_LIMIT = "GET_LIST_ORGANIZATION_LIMIT";

export const HIT_ADD_EMPLOYEE = "HIT_ADD_EMPLOYEE";

export const HIT_ADD_NODE_EMPLOYEE = "HIT_ADD_NODE_EMPLOYEE";
export const HIT_UPDATE_NODE_EMPLOYEE = "HIT_UPDATE_NODE_EMPLOYEE";

export const HIT_STRUCTURE = "HIT_STRUCTURE";
export const GET_STRUCTURE = "GET_STRUCTURE";

export const HIT_LIST_JOB = "HIT_LIST_JOB";
export const GET_LIST_JOB = "GET_LIST_JOB";

export const HIT_UPDATE_STRUCTURE = "HIT_UPDATE_STRUCTURE";
export const GET_UPDATE_STRUCTURE = "GET_UPDATE_STRUCTURE";

export const HIT_ADD_STRUCTURE = "HIT_ADD_STRUCTURE";
export const HIT_EDIT_STRUCTURE = "HIT_EDIT_STRUCTURE";
export const HIT_ADD_NODE_STRUCTURE = "HIT_ADD_NODE_STRUCTURE";

export const HIT_IMPORT_PROCESS_ORG = "HIT_IMPORT_PROCESS_ORG";
export const GET_IMPORT_PROCESS_ORG = "GET_IMPORT_PROCESS_ORG";

export const HIT_EMPLOYEE_CHART = "HIT_EMPLOYEE_CHART";
export const HIT_UPDATE_EMPLOYEE = "HIT_UPDATE_EMPLOYEE";
export const GET_EMPLOYEE_CHART = "GET_EMPLOYEE_CHART";

export const HIT_JOB_LEVEL = "HIT_JOB_LEVEL";
export const GET_JOB_LEVEL = "GET_JOB_LEVEL";

export const HIT_CREATE_JOB_LEVEL = "HIT_CREATE_JOB_LEVEL";
export const HIT_UPDATE_JOB_LEVEL = "HIT_UPDATE_JOB_LEVEL";

export const HIT_FOCUS_POSITION = "HIT_FOCUS_POSITION";
export const GET_FOCUS_POSITION = "GET_FOCUS_POSITION";

export const HIT_FOCUS_POSITION_EMPLOYEE = "HIT_FOCUS_POSITION_EMPLOYEE";
export const GET_FOCUS_POSITION_EMPLOYEE = "GET_FOCUS_POSITION_EMPLOYEE";

export const HIT_BANK_LIST = "HIT_BANK_LIST";
export const GET_BANK_LIST = "GET_BANK_LIST";

export const HIT_REGION_CREATE = "HIT_REGION_CREATE";
export const HIT_REGION_UPDATE = "HIT_REGION_UPDATE";

export const HIT_CREATE_STRUCTURE_COPY = "HIT_CREATE_STRUCTURE_COPY";

export const HIT_LIST_DIRECTORATE = "HIT_LIST_DIRECTORATE";
export const GET_LIST_DIRECTORATE = "GET_LIST_DIRECTORATE";

export const HIT_CREATE_DIRECTORATE = "HIT_CREATE_DIRECTORATE";
export const HIT_UPDATE_DIRECTORATE = "HIT_UPDATE_DIRECTORATE";
export const HIT_DELETE_DIRECTORATE = "HIT_DELETE_DIRECTORATE";

export const HIT_COPY_EMPLOYEE = "HIT_COPY_EMPLOYEE";
export const GET_COPY_EMPLOYEE = "GET_COPY_EMPLOYEE";

export const HIT_LIST_DIVISION = "HIT_LIST_DIVISION";
export const GET_LIST_DIVISION = "GET_LIST_DIVISION";

export const HIT_DETAIL_STRUCTURE = "HIT_DETAIL_STRUCTURE";
export const GET_DETAIL_STRUCTURE = "GET_DETAIL_STRUCTURE";

export const HIT_CREATE_EMPLOYEE = "HIT_CREATE_EMPLOYEE";
export const HIT_EDIT_EMPLOYEE = "HIT_EDIT_EMPLOYEE";

export const SET_PAGINATION_EMPLOYEE = "SET_PAGINATION_EMPLOYEE";
export const SET_PAGINATION_STRUCTURE = "SET_PAGINATION_STRUCTURE";
